import { ActionTracker } from '@varsitytutors/event-tracker';
import { pageParams } from 'mex_components/app/scripts/tracking/action_tracker.js';
import addStartupScript from 'mex_components/app/scripts/events/addStartupScript';

addStartupScript(() => {
  const actionTracker = new ActionTracker({
    endpoint: window.components.action_tracker.endpoint,
    applicationId: window.components.action_tracker.application_id
  });

  const page = pageParams(window.vtItemDetails.page);
  const params = {
    page: page,
    domEventData: {
      target: 'page',
      data: window.vtItemDetails.inventoryData
    },
    customEventData: {
      action: 'inventory',
      category: 'reach'
    },
    pageRequestId: window.vtItemDetails.page.page_request_id || 'undefined'
  };

  if(actionTracker) actionTracker.track(params);
});
